import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {
  SifrarnikDataService,
  SifrarnikModel,
} from '../../services/sifrarnik-data.service';
import { SubSink } from 'subsink';
import { SifrarnikAddDialogComponent } from '../sifrarnik-add-dialog/sifrarnik-add-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { localImages, stringsList } from '../../../../constants/app-config';
import { TranslateService } from '@ngx-translate/core';
import { SmallDialogComponent } from '../../../../atoms/small-dialog/small-dialog.component';
import { SifrarnikBulkImportComponent } from '../sifrarnik-bulk-import/sifrarnik-bulk-import.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { fromEvent, of } from 'rxjs';
import { debounceTime, map, switchAll, tap } from 'rxjs/operators';
import { log } from 'console';
import { BulkDeleteServiceInput, ModelType } from 'src/app/API.service';
import { BulkDeleteService } from 'src/app/services/bulk-delete.service';

@Component({
  selector: 'app-sifrarnik-table',
  templateUrl: './sifrarnik-table.component.html',
  styleUrls: [
    '../../../../styles/styles.css',
    './sifrarnik-table.component.css',
  ],
})
export class SifrarnikTableComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  constructor(
    public sifrarnikDataService: SifrarnikDataService,
    public dialog: MatDialog,
    public bulkDeleteService: BulkDeleteService,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    private input: ElementRef<HTMLInputElement>
  ) {
    const obs = fromEvent(this.input.nativeElement, 'keyup').pipe(
      map((e: any) => {
        return e.target.value;
      }),
      debounceTime(250),
      tap(() => {
        this.isSearchFilterOn = true;
      }),
      map((searchInput: string) => {
        return of(searchInput?.toLowerCase());
      }),
      switchAll()
    );
    obs.subscribe(async (data) => {
      if (data.length) {
        const trimmedSentence = data.replace(/\s+/g, '');
        this.sifrarnikDataService
          .filterCodebooks(this.userID as string, trimmedSentence)
          .catch((err) => console.error(err));
      } else {
        this.sifrarnikDataService
          .initializeData(this.userID as string)
          .catch((err) => console.error(err));
        this.isSearchFilterOn = false;
      }
    });
  }

  displayedColumns: string[] = [
    'checkbox',
    'firma',
    'idBroj',
    'sifra',
    'vatNumber',
    'actions',
  ];
  private subs = new SubSink();
  dataSource!: MatTableDataSource<any>;
  searchTemplateInput: string = '';
  isLoading = false;
  isSearchFilterOn = false;
  localImages = localImages;
  stringsList = stringsList;
  @ViewChild(MatSort) sort!: MatSort;
  showIcon = false;
  showClearIcon = false;
  isInputFocused = false;
  private searchTimer: any; // To store the timer ID for debounce
  isHovered: boolean = false;
  isHovered1: boolean = false;
  isAdditionalDataBeingFetched: boolean = false;
  userID!: string | null;
  private savedScrollPosition = 0;
  selectedInvoicesNum: number = 0;
  @ViewChild('scrollableContainer')
  scrollableContainer!: ElementRef<HTMLElement>;

  ngOnInit(): void {
    this.isLoading = true;
    this.userID = localStorage.getItem('userID');
    this.sifrarnikDataService.initializeData(this.userID as string).then(() => {
      this.subs.sink = this.sifrarnikDataService.sifre.subscribe((data) => {
        this.isLoading = true;

        // temporarly commented out
        // data.sort((a, b) => {
        //   const dateA = a.updatedAt ? new Date(a.updatedAt) : new Date(0);
        //   const dateB = b.updatedAt ? new Date(b.updatedAt) : new Date(0);

        //   if (dateA > dateB) {
        //     return -1;
        //   } else if (dateA < dateB) {
        //     return 1;
        //   } else {
        //     return 0;
        //   }
        // });

        this.dataSource = new MatTableDataSource<any>(data);
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = (item, filter) => {
          // Replace 'companyName' with the property you want to filter by
          return item.companyName.toLowerCase().includes(filter.toLowerCase());
        };
        if (data.length) {
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
    });
  }

  async onScroll(e: any) {
    if (this.isSearchFilterOn) {
      return;
    }
    const scrollableContainer = this.scrollableContainer.nativeElement;
    const containerHeight = scrollableContainer.clientHeight;
    const scrollHeight = scrollableContainer.scrollHeight;
    const scrollTop = scrollableContainer.scrollTop;

    // Calculate the remaining distance to the bottom
    const remainToScrollToBottom = scrollHeight - (scrollTop + containerHeight);

    this.savedScrollPosition = scrollTop;

    // Define a threshold percentage (e.g., 90%) for triggering data loading
    const thresholdPercentage = 0.9;

    if (
      remainToScrollToBottom < containerHeight * thresholdPercentage &&
      !this.isAdditionalDataBeingFetched
    ) {
      this.isAdditionalDataBeingFetched = true;

      // Call your data fetching function here (replace this with your actual data fetching logic)
      await this.sifrarnikDataService
        .fetchAdditionalCodebooks(this.userID as string)
        .then(() => {
          this.isAdditionalDataBeingFetched = false;
        });
    }
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngAfterViewInit(): void {
    if (this.dataSource) this.dataSource.sort = this.sort;
  }

  toggleIcon() {
    this.showClearIcon = !!this.searchTemplateInput;
    clearTimeout(this.searchTimer);

    // Start a new timer for debounce
    this.searchTimer = setTimeout(() => {
      this.applyFilter(this.searchTemplateInput);
    }, 300);
  }

  clearSearch(): void {
    this.searchTemplateInput = '';
    this.showClearIcon = false;
    this.dataSource.filter = '';
    this.sifrarnikDataService
      .initializeData(this.userID as string)
      .catch((err) => console.error(err));
    this.isSearchFilterOn = false;
  }

  sortData(e: any) {
    this.dataSource.data = this.dataSource.data.sort((a, b) => {
      const isAsc = e.direction === 'asc';
  
      // Convert 'code' values to numbers for proper numeric sorting
      const aValue = Number(a[e.active]);
      const bValue = Number(b[e.active]);
  
      return this.compare(aValue, bValue, isAsc);
    });
  }
  

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // applyFilter(event: Event): void {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  // }

  addNewCode(): void {
    const dialogData = {
      action: 'Add',
    };
    const dialogRef = this.dialog.open(SifrarnikAddDialogComponent, {
      width: '420px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.snackBar.open('Code successfully added', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
      }
    });
  }

  openBulkImport(): void {
    const dialogRef = this.dialog.open(SifrarnikBulkImportComponent, {
      width: '480px',
      height: '386px',
      hasBackdrop: true,
    });

    dialogRef.afterClosed().subscribe(async (data: boolean) => {
      console.log(data, 'heh');
    });
  }

  editCode(code: SifrarnikModel): void {
    const dialogData = {
      action: 'Edit',
      data: Object.assign({}, code),
    };
    const dialogRef = this.dialog.open(SifrarnikAddDialogComponent, {
      width: '420px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((data) => {});
  }

  deleteCode(item: any): void {
    let dialogData = {
      heading: this.translate.instant('deleteCode'),
      contentPartOne: this.translate.instant('codeContentPartOne'),
      contentFile: item.companyName,
      contentPartTwo: this.translate.instant('codeContentPartTwo'),
      action: 'Delete code',
    };
    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe((response) => {
      if (response.action === stringsList.doAction) {
        this.sifrarnikDataService.removeSifra(item);
      }
    });
  }

  openSmallDialogProperties(data: any) {
    return {
      width: '460px',
      data: data,
    };
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  toggleCheckbox(code: any) {
    if (code.selected) {
      this.selectedInvoicesNum++;
    } else {
      this.selectedInvoicesNum--;
    }
  }

  toggleAllSelection(seed: boolean) {
    console.log(seed);
    if (seed == true) {
      this.dataSource.data.forEach((obj) => {
        obj.selected = true;
      });
      this.selectedInvoicesNum = this.dataSource.data.length;
    } else {
      this.dataSource.data.forEach((obj) => {
        obj.selected = false;
      });
      this.selectedInvoicesNum = 0;
    }

    console.log('2', this.dataSource.data);

    // this.invoices.forEach((invoice: any) => {
    //   invoice.selected = seed;
    // });
    // if (seed == true) {
    //   this.selectedInvoicesNum = this.invoices.length;
    // } else {
    //   this.selectedInvoicesNum = 0;
    // }
  }

  async bulkDeleteInvoices() {
    let codesForDelete = this.dataSource.data.filter((code: any) => {
      return code.selected;
    });
    let plural = codesForDelete.length > 1 ? true : false;
    let messages = {
      heading: 'Delete codes?',
      contentPartOne:
        'Are you sure you want to delete these codes from codebook?',
      action: this.translate.instant('Delete codes'),
    };

    if (!plural) {
      messages.heading = 'Delete code?';
      messages.contentPartOne =
        'Are you sure you want to delete this code from codebook?';
      messages.action = 'Delete code';
    }

    let dialogData = {
      heading: messages.heading,
      contentPartOne: messages.contentPartOne,
      //  contentPartTwo: this.translate.instant('invoiceContentPartTwo'),
      action: messages.action,
    };

    const dialogRef = this.dialog.open(
      SmallDialogComponent,
      this.openSmallDialogProperties(dialogData)
    );
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response?.action === stringsList.doAction) {
        this.isLoading = true;

        let ids: BulkDeleteServiceInput = {
          ids: [],
          type: ModelType.CODEBOOK,
        };
        let selected = this.dataSource.data.filter((code: any) => {
          return code.selected;
        });

        ids.ids = selected.map((code: any) => {
          return code.id;
        });

        let snackMessage = 'Selected codes have been deleted';
        if (!plural) {
          snackMessage = 'Selected code has been deleted';
        }

        await this.bulkDeleteService
          .BulkDeleteService(ids)
          .catch((err) => console.log(err));
        this.snackBar.open(snackMessage, 'Dismiss', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        this.dataSource.data = this.dataSource.data.filter((code: any) => {
          return !code.selected;
        });
        this.selectedInvoicesNum = 0;
        this.isLoading = false;
      }
    });
  }
}
